/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCVOpenIcon16Light = forwardRef('ArrowCollapseCVOpenIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.202 2.495a1.7 1.7 0 0 0-2.404 0L3.646 5.646a.5.5 0 1 0 .708.708l3.151-3.152a.7.7 0 0 1 .99 0l3.151 3.152a.5.5 0 0 0 .708-.708L9.202 2.495Z" }),
        React.createElement("path", { d: "M9.202 13.505a1.7 1.7 0 0 1-2.404 0l-3.152-3.151a.5.5 0 0 1 .708-.708l3.151 3.152a.7.7 0 0 0 .99 0l3.151-3.152a.5.5 0 0 1 .708.708l-3.152 3.151Z" })));
});
